export interface MobileCheckinBean {
  creatorOnline: boolean;
  locationId: number;
  purpose: string;
  message: string;
}

// {
//     "locationId": 20593,
//     "creatorOnline": true,
//     "message": "Test 1234",
//     "purpose": "Deposit / Withdrawal"
// }

export interface MobileQueueListRequestBean {
  ascending: boolean;
  locationId: null;
  purposes: null;
  queuedDateFrom: string;
  queuedDateTo: string;
  queuedUser: null;
  queuedUserId: null;
  routedTo: null;
  statuses: number[];
}
// {
//   "ascending": true,
//   "locationId": null,
//   "purposes": null,
//   "queuedDateFrom": "03/20/2025 00:00:00",
//   "queuedDateTo": "03/20/2025 23:59:59",
//   "queuedUser": null,
//   "queuedUserId": null,
//   "routedTo": null,
//   "statuses": [
//       0,
//       1,
//       2
//   ]
// }

export interface MobileQueueBean {
  id: number;
  queuedUser: QueuedUser;
  message: string;
  status: number;
  routedTo: null;
  purpose: string;
  creatorOnline: boolean;
  queuePosition: number;
  userType: number;
  userName: null;
  locationId: number;
  queuedDate: string;
  lastUpdated: string;
  routedDate: null;
  queuedUserId: string;
}

export interface QueuedUser {
  userId: string;
  name: string;
  phone: string;
}

export interface MobileUpdateQueueBean {
    creatorOnline: boolean;
    id: number;
    locationId: number;
    queuePosition: number;
    status: number;
}
// {
//   "creatorOnline": true,
//   "id": 868,
//   "lastUpdated": null,
//   "locationId": 20593,
//   "message": null,
//   "purpose": null,
//   "queuePosition": 1,
//   "queuedDate": null,
//   "queuedUser": null,
//   "queuedUserId": null,
//   "routedDate": null,
//   "routedTo": null,
//   "routedToId": null,
//   "status": 2
// }



export enum QueueStatus {
  PENDING = 0,
  ROUTED = 1,
  CUSTOMER_HERE = 2,
  ABANDONED = 3,
  CLOSED = 4,
  EXPIRED = 5
}

// {
//     "status": {
//         "code": 0,
//         "message": "OK"
//     },
//     "message": "OK",
//     "validationErrorList": [],
//     "entity": [
//         {
//             "id": 850,
//             "queuedUser": {
//                 "userId": "4867500",
//                 "name": "John Doe",
//                 "phone": "2250100"
//             },
//             "message": "",
//             "status": 0,
//             "routedTo": null,
//             "purpose": "Deposit / Withdrawal",
//             "creatorOnline": false,
//             "queuePosition": 1,
//             "userType": 0,
//             "userName": null,
//             "locationId": 20593,
//             "queuedDate": "03/20/2025 13:17:38",
//             "lastUpdated": "03/20/2025 13:17:38",
//             "routedDate": null,
//             "queuedUserId": "4867500"
//         }
//     ]
// }

